{
  "version": "2.0",
  "metadata": {
    "apiVersion": "2018-08-01",
    "endpointPrefix": "rds-data",
    "jsonVersion": "1.1",
    "protocol": "rest-json",
    "serviceFullName": "AWS RDS DataService",
    "serviceId": "RDS Data",
    "signatureVersion": "v4",
    "signingName": "rds-data",
    "uid": "rds-data-2018-08-01"
  },
  "operations": {
    "BatchExecuteStatement": {
      "http": {
        "requestUri": "/BatchExecute",
        "responseCode": 200
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "secretArn",
          "sql"
        ],
        "members": {
          "database": {},
          "parameterSets": {
            "type": "list",
            "member": {
              "shape": "S4"
            }
          },
          "resourceArn": {},
          "schema": {},
          "secretArn": {},
          "sql": {},
          "transactionId": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "updateResults": {
            "type": "list",
            "member": {
              "type": "structure",
              "members": {
                "generatedFields": {
                  "shape": "Sj"
                }
              }
            }
          }
        }
      }
    },
    "BeginTransaction": {
      "http": {
        "requestUri": "/BeginTransaction",
        "responseCode": 200
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "secretArn"
        ],
        "members": {
          "database": {},
          "resourceArn": {},
          "schema": {},
          "secretArn": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "transactionId": {}
        }
      }
    },
    "CommitTransaction": {
      "http": {
        "requestUri": "/CommitTransaction",
        "responseCode": 200
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "secretArn",
          "transactionId"
        ],
        "members": {
          "resourceArn": {},
          "secretArn": {},
          "transactionId": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "transactionStatus": {}
        }
      }
    },
    "ExecuteSql": {
      "http": {
        "requestUri": "/ExecuteSql",
        "responseCode": 200
      },
      "input": {
        "type": "structure",
        "required": [
          "awsSecretStoreArn",
          "dbClusterOrInstanceArn",
          "sqlStatements"
        ],
        "members": {
          "awsSecretStoreArn": {},
          "database": {},
          "dbClusterOrInstanceArn": {},
          "schema": {},
          "sqlStatements": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "sqlStatementResults": {
            "type": "list",
            "member": {
              "type": "structure",
              "members": {
                "numberOfRecordsUpdated": {
                  "type": "long"
                },
                "resultFrame": {
                  "type": "structure",
                  "members": {
                    "records": {
                      "type": "list",
                      "member": {
                        "type": "structure",
                        "members": {
                          "values": {
                            "type": "list",
                            "member": {
                              "shape": "Sy"
                            }
                          }
                        }
                      }
                    },
                    "resultSetMetadata": {
                      "type": "structure",
                      "members": {
                        "columnCount": {
                          "type": "long"
                        },
                        "columnMetadata": {
                          "shape": "S15"
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      "deprecated": true
    },
    "ExecuteStatement": {
      "http": {
        "requestUri": "/Execute",
        "responseCode": 200
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "secretArn",
          "sql"
        ],
        "members": {
          "continueAfterTimeout": {
            "type": "boolean"
          },
          "database": {},
          "includeResultMetadata": {
            "type": "boolean"
          },
          "parameters": {
            "shape": "S4"
          },
          "resourceArn": {},
          "schema": {},
          "secretArn": {},
          "sql": {},
          "transactionId": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "columnMetadata": {
            "shape": "S15"
          },
          "generatedFields": {
            "shape": "Sj"
          },
          "numberOfRecordsUpdated": {
            "type": "long"
          },
          "records": {
            "type": "list",
            "member": {
              "shape": "Sj"
            }
          }
        }
      }
    },
    "RollbackTransaction": {
      "http": {
        "requestUri": "/RollbackTransaction",
        "responseCode": 200
      },
      "input": {
        "type": "structure",
        "required": [
          "resourceArn",
          "secretArn",
          "transactionId"
        ],
        "members": {
          "resourceArn": {},
          "secretArn": {},
          "transactionId": {}
        }
      },
      "output": {
        "type": "structure",
        "members": {
          "transactionStatus": {}
        }
      }
    }
  },
  "shapes": {
    "S4": {
      "type": "list",
      "member": {
        "type": "structure",
        "members": {
          "name": {},
          "value": {
            "shape": "S7"
          }
        }
      }
    },
    "S7": {
      "type": "structure",
      "members": {
        "blobValue": {
          "type": "blob"
        },
        "booleanValue": {
          "type": "boolean"
        },
        "doubleValue": {
          "type": "double"
        },
        "isNull": {
          "type": "boolean"
        },
        "longValue": {
          "type": "long"
        },
        "stringValue": {}
      }
    },
    "Sj": {
      "type": "list",
      "member": {
        "shape": "S7"
      }
    },
    "Sy": {
      "type": "structure",
      "members": {
        "arrayValues": {
          "shape": "Sz"
        },
        "bigIntValue": {
          "type": "long"
        },
        "bitValue": {
          "type": "boolean"
        },
        "blobValue": {
          "type": "blob"
        },
        "doubleValue": {
          "type": "double"
        },
        "intValue": {
          "type": "integer"
        },
        "isNull": {
          "type": "boolean"
        },
        "realValue": {
          "type": "float"
        },
        "stringValue": {},
        "structValue": {
          "type": "structure",
          "members": {
            "attributes": {
              "shape": "Sz"
            }
          }
        }
      }
    },
    "Sz": {
      "type": "list",
      "member": {
        "shape": "Sy"
      }
    },
    "S15": {
      "type": "list",
      "member": {
        "type": "structure",
        "members": {
          "arrayBaseColumnType": {
            "type": "integer"
          },
          "isAutoIncrement": {
            "type": "boolean"
          },
          "isCaseSensitive": {
            "type": "boolean"
          },
          "isCurrency": {
            "type": "boolean"
          },
          "isSigned": {
            "type": "boolean"
          },
          "label": {},
          "name": {},
          "nullable": {
            "type": "integer"
          },
          "precision": {
            "type": "integer"
          },
          "scale": {
            "type": "integer"
          },
          "schemaName": {},
          "tableName": {},
          "type": {
            "type": "integer"
          },
          "typeName": {}
        }
      }
    }
  }
}